export default __webpack_public_path__ + "static/media/knauflogo.4796d869.png";